<template>
  <div class="list">
    <div class="header">
        <div class="header-label">
            Ingeplande Notificaties:
        </div>
    </div>
    <div class="notification" v-for="(notification, index) in notifications" :key="notification.id">
        <DisplayNotification
            :notification="{ ...notification, status: 'scheduled'}"
            :index="index"
            :channels="channels"
        />
    </div>
  </div>
</template>

<script>
import DisplayNotification from "@/components/DisplayNotification";

export default {
    props: ['notifications', 'channels'],
    components: {
        DisplayNotification,
    },
    methods: {
        cancelNotification (id, index) {
            this.$api.deleteScheduledNotification(id)
            this.$delete(this.notifications, index)
            return false
        }
    },
    name: "ListScheduledNotifications",
}
</script>

<style scoped>
  .list {
        margin-top: 50px;
    }
    .header {
        display: flex;
        align-content: stretch;
    }
    .header-label {
        flex-grow: 1;
    }
    .limit input {
        width: 40px;
        margin-bottom: 4px;
        box-sizing: border-box;
        padding: 8px;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        font-size: 16px;
        border: 0 solid silver;
        border-bottom: 1px solid #e0e0e0;
    }
</style>
